import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    tabsView: [],
    tabsPreferences: [],
    currentTabs: [],
    activeCustomViews: [],
    loadMoreFilters: true,
    filtersPage: 0,
    userPreferences: []
  },
  mutations: {
    setTabsView: (state, data) => {
      state.tabsView = data
    },
    setTabsPreferences: (state, data) => {
      state.tabsPreferences = data
    },
    setCurrentTabs: (state, data) => {
      state.currentTabs = data
    },
    setActiveCustomViews: (state, data) => {
      state.activeCustomViews = data
    },
    setLoadMoreFilters: (state, data) => {
      state.loadMoreFilters = data
    },
    setFiltersPage: (state, data) => {
      state.filtersPage = data
    },
    setUserPreferences: (state, data) => {
      state.userPreferences = data
    },
  },
  getters: {
    tabsView: (state) => {
      return state.tabsView
    },
    tabsPreferences: (state) => {
      return state.tabsPreferences
    },
    currentTabs: (state) => {
      return state.currentTabs
    },
    activeCustomViews: (state) => {
      return state.activeCustomViews
    },
    getLoadMoreFilters: (state) => {
      return state.loadMoreFilters
    },
    getFiltersPage: (state) => {
      return state.filtersPage
    },
    getUserPreferences: (state) => {
      return state.userPreferences
    },
  }
}  